import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupTypeRoommates = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42 0H0V42H42V0Z",
			fill: "#F6EA9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78906 14.946L12.13 12.1767C12.1713 12.1423 12.1679 12.0928 12.2337 12.0911L15.4178 9.4502L21.0956 14.1597L26.7701 9.45103L33.3997 14.9435L33.4013 32.3465H8.78991L8.78906 14.946Z",
			fill: "#F0BC00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3994 14.9434L26.7705 9.45117L21.0957 14.1602L15.418 9.4502L12.2334 12.0908C12.1679 12.0926 12.1711 12.1424 12.1299 12.1768L8.78906 14.9463L8.79004 32.3467H33.4014L33.3994 14.9434ZM34.4014 33.3467H7.79004L7.78906 14.4756L11.4092 11.4746C11.4689 11.4032 11.5642 11.3081 11.7031 11.2295C11.7054 11.2282 11.7077 11.2269 11.71 11.2256L15.418 8.15137L21.0957 12.8594L26.7695 8.15234L34.3994 14.4736L34.4014 33.3467Z",
			fill: "#402900"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8685 23.1442C27.3589 23.2852 28.5527 22.1623 28.5341 20.7097C28.5147 19.1757 27.1667 18.0956 25.6526 18.3684C24.4758 18.5799 23.6631 19.5751 23.6799 20.776C23.6968 22.0172 24.5887 23.0233 25.8676 23.1442H25.8685Z",
			fill: "#925D00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7639 24.5176H26.4476C28.7474 24.5176 30.6139 26.3764 30.6139 28.6648V32.348H21.5977V28.6648C21.5977 26.3755 23.465 24.5176 25.7639 24.5176Z",
			fill: "#925D00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8489 23.1442C17.3394 23.2852 18.5331 22.1623 18.5146 20.7097C18.4952 19.1757 17.1472 18.0956 15.6331 18.3684C14.4562 18.5799 13.6436 19.5751 13.6604 20.776C13.6773 22.0172 14.5692 23.0233 15.8481 23.1442H15.8489Z",
			fill: "#402900"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7444 24.5176H16.4281C18.7279 24.5176 20.5943 26.3764 20.5943 28.6648V32.348H11.5781V28.6648C11.5781 26.3755 13.4454 24.5176 15.7444 24.5176Z",
			fill: "#402900"
		})
	]
});
export default SvgGroupTypeRoommates;
